<div class="txn-approval-page">
  <div class="txn-approval-container">

    <!-- Firm header -->
    @if ((step === 'details' || step === 'otp' || step === 'result') && details?.Firm) {
      <div class="sbl-firm-header">
        @if (details.Firm.FirmLogo) {
          <img class="logo-img" [src]="details.Firm.FirmLogo" [alt]="details.Firm.FirmName || 'Firm'" />
        }
        @if (details.Firm.FirmName) {
          <span class="sbl-firm-name">{{ details.Firm.FirmName }}</span>
        }
      </div>
    }

    @if (step === 'loading') {
      <div class="txn-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading your request...</span>
      </div>
    }

    @if (step === 'error') {
      <div class="status-banner status-banner--error">
        <div class="status-banner__icon"><i class="pi pi-exclamation-circle"></i></div>
        <div>
          <p class="status-banner__title">This approval link isn't valid</p>
          <p class="status-banner__subtitle">{{ loadError }}</p>
        </div>
      </div>
    }

    @if (step === 'result') {
      @if (isSuccessBanner()) {
        <div class="status-banner status-banner--success">
          <div class="status-banner__icon"><i class="pi pi-check"></i></div>
          <div>
            <p class="status-banner__title">{{ getBannerTitle() }}</p>
            <p class="status-banner__subtitle">{{ getBannerSubtitle() }}</p>
          </div>
        </div>
      } @else {
        <div class="status-banner status-banner--error">
          <div class="status-banner__icon"><i class="pi pi-exclamation-circle"></i></div>
          <div>
            <p class="status-banner__title">{{ getBannerTitle() }}</p>
            <p class="status-banner__subtitle">{{ getBannerSubtitle() }}</p>
          </div>
        </div>
      }
    }

    @if (step === 'details' || step === 'otp' || step === 'result') {
      <div class="txn-reference-label">
        <i class="pi pi-folder-open"></i>
        <span>{{ requestTypeLabel }} &middot; Reference #{{ details?.RequestID ?? '--' }}</span>
      </div>

      <!-- Amount -->
      <div class="txn-amount-card">
        <div>
          <div class="txn-amount-card__label">{{ isPayment ? 'Payment Amount' : 'Draw Amount' }}</div>
          <div class="txn-amount-card__value">{{ (details?.Amount | currency: 'USD') ?? '--' }}</div>
        </div>
        <div class="txn-amount-card__icon"><i class="pi pi-dollar"></i></div>
      </div>

      <!-- Loan / Line details -->
      <div class="detail-card detail-card--sender">
        <div class="detail-card__header">
          <h3 class="detail-card__title">{{ isPayment ? 'Pay To (Your Line)' : 'Your Line of Credit' }}</h3>
          <span class="detail-card__badge detail-card__badge--from">LOAN</span>
        </div>
        <div class="detail-grid">
          <div class="detail-field">
            <span class="detail-field__label">Loan Account</span>
            <span class="detail-field__value">{{ details?.Loan?.LoanAccountNumber ?? '--' }}</span>
          </div>
          <div class="detail-field">
            <span class="detail-field__label">Product</span>
            <span class="detail-field__value">{{ details?.Loan?.ProductName ?? '--' }}</span>
          </div>
        </div>
      </div>

      <!-- Draw: disburse-to -->
      @if (isDraw) {
        <div class="detail-card detail-card--recipient">
          <div class="detail-card__header">
            <h3 class="detail-card__title">Disburse To</h3>
            <span class="detail-card__badge detail-card__badge--to">TO</span>
          </div>
          <div class="detail-grid">
            <div class="detail-field">
              <span class="detail-field__label">Method</span>
              <span class="detail-field__value">{{ details?.Draw?.DisbursementMethod ?? '--' }}</span>
            </div>
            <div class="detail-field">
              <span class="detail-field__label">Account Name</span>
              <span class="detail-field__value">{{ disburseToAccount?.AccountName ?? '--' }}</span>
            </div>
            <div class="detail-field">
              <span class="detail-field__label">Account Number</span>
              <span class="detail-field__value">{{ disburseToAccount?.AccountNumber ?? '--' }}</span>
            </div>
            @if (disburseToAccount?.BankName) {
              <div class="detail-field">
                <span class="detail-field__label">Bank Name</span>
                <span class="detail-field__value">{{ disburseToAccount.BankName }}</span>
              </div>
            }
          </div>
        </div>
      }

      <!-- Payment: pay-from + breakdown -->
      @if (isPayment) {
        <div class="detail-card detail-card--recipient">
          <div class="detail-card__header">
            <h3 class="detail-card__title">Pay From</h3>
            <span class="detail-card__badge detail-card__badge--to">FROM</span>
          </div>
          <div class="detail-grid">
            <div class="detail-field">
              <span class="detail-field__label">Payment Type</span>
              <span class="detail-field__value">{{ details?.Payment?.PaymentType ?? '--' }}</span>
            </div>
            <div class="detail-field">
              <span class="detail-field__label">Account Name</span>
              <span class="detail-field__value">{{ payFromAccount?.AccountName ?? '--' }}</span>
            </div>
            <div class="detail-field">
              <span class="detail-field__label">Account Number</span>
              <span class="detail-field__value">{{ payFromAccount?.AccountNumber ?? '--' }}</span>
            </div>
          </div>
        </div>
      }
    }

    <!-- Details actions -->
    @if (step === 'details') {
      @if (!canApprove && message) {
        <div class="status-banner status-banner--error">
          <div class="status-banner__icon"><i class="pi pi-info-circle"></i></div>
          <div>
            <p class="status-banner__title">No action available</p>
            <p class="status-banner__subtitle">{{ message }}</p>
          </div>
        </div>
      }
      @if (canApprove && isPayment) {
        <div class="sbl-auth">
          <div class="sbl-auth__row">
            <div class="sbl-auth__field">
              <label class="sbl-auth__label" for="sbl-auth-name">Name</label>
              <input id="sbl-auth-name" class="sbl-auth__input" type="text" [value]="payAuthName" disabled />
            </div>
            <div class="sbl-auth__field">
              <label class="sbl-auth__label" for="sbl-auth-date">Effective Date</label>
              <input id="sbl-auth-date" class="sbl-auth__input" type="text" [value]="payAuthEffectiveDate" disabled />
            </div>
            <div class="sbl-auth__field">
              <label class="sbl-auth__label" for="sbl-auth-sign">Signature</label>
              <input id="sbl-auth-sign" class="sbl-auth__input" type="text" name="paySignature"
                placeholder="Type your full legal name" autocomplete="off"
                [class.sbl-auth__input--error]="signatureMismatchError" [(ngModel)]="paySignature" />
              @if (signatureMismatchError) {
                <div class="sbl-auth__error">{{ signatureMismatchError }}</div>
              }
            </div>
          </div>
          <label class="sbl-auth__consent" for="sbl-ach-auth">
            <input id="sbl-ach-auth" type="checkbox" name="payAchAuthorized" [(ngModel)]="payAchAuthorized" />
            <span>I authorize this one-time payment from the account selected above to pay my Bell Bank loan.</span>
          </label>
        </div>
      }
      @if (otpError) {
        <div class="txn-inline-error">{{ otpError }}</div>
      }
      @if (canApprove) {
        <div class="txn-actions">
          <button type="button" class="txn-btn txn-btn--primary" [disabled]="isResendingOtp || !isPaymentAuthComplete" (click)="onContinueClick()">
            {{ isResendingOtp ? 'Sending code...' : 'Continue' }}
          </button>
        </div>
      }
    }

    <!-- OTP -->
    @if (step === 'otp') {
      <div class="txn-otp-card">
        <div class="txn-otp-icon"><i class="pi pi-lock"></i></div>
        <div class="txn-otp-title">Verify it's you</div>
        <div class="txn-otp-subtitle">
          We sent a 6-digit code
          @if (details?.maskedEmail) { to <strong>{{ details.maskedEmail }}</strong> }
          @if (details?.maskedPhone) { and <strong>{{ details.maskedPhone }}</strong> }.
          Enter it below to approve this {{ isPayment ? 'payment' : 'draw' }}.
        </div>

        <div class="txn-otp-single-row">
          <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="one-time-code"
            class="txn-otp-single-input" name="otp" [(ngModel)]="otp" (ngModelChange)="onOtpValueChange($event)" />
        </div>

        @if (otpError) {
          <div class="txn-otp-error">{{ otpError }}</div>
        }

        <div class="txn-otp-resend">
          Didn't get it?
          <button type="button" class="txn-otp-resend-link" [disabled]="isResendingOtp" (click)="resendOtp()">
            {{ isResendingOtp ? 'Sending...' : 'Send a new code' }}
          </button>
        </div>

        <button type="button" class="txn-btn txn-btn--primary txn-otp-submit"
          [disabled]="isSubmittingOtp || (otp?.length ?? 0) < 6" (click)="onOtpSubmit()">
          {{ isSubmittingOtp ? 'Approving...' : (isPayment ? 'Approve payment' : 'Approve draw') }}
        </button>
      </div>
    }
  </div>
</div>
